import React, { FunctionComponent, useState } from 'react';
import { TeamsSubFolderProps } from './types';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { meetingFilesSelectedSelectors } from '../../../../../app/resource/meeting-shortcuts/meeting-shortcuts.selectors';

export const MeetingsSubFolder: FunctionComponent<TeamsSubFolderProps> = ({ subFolder, onSelectChange }) => {
  const [selected, setSelected] = useState(false);
  const meetingShortcutsSelected = useSelectWithParams(meetingFilesSelectedSelectors.selectResourceById, subFolder.id);

  return (
    <div>
      <button
        className={`subdirectory-button panel small-panel flex aic px-1 mb-1 ${
          meetingShortcutsSelected && meetingShortcutsSelected.id === subFolder.id ? 'focus-title' : ''
        }`}
        title=""
        onClick={() => {
          const newSelected = !selected;
          setSelected(newSelected);
          onSelectChange(subFolder, newSelected);
        }}
      >
        <i
          className={`icon2-folder mr-1 ${meetingShortcutsSelected?.id === subFolder.id ? 'darkGray' : 'blueGray'}`}
        ></i>
        {subFolder.name}
      </button>
    </div>
  );
};
